{
  "zh-CN": {
    "title": {
      "locations": {
        "index": "地点",
        "places": "所有地点"
      },
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "vehiclePlaque": "%{vehicle} 的命名铭牌",
      "home": "首页",
      "ships": {
        "index": "舰船",
        "viewer": "舰船查看器"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "%{name} 图片",
      "shipVideos": "%{name} 视频",
      "shipHistory": "%{name} 历史",
      "componentHistory": "%{name} 历史",
      "shipViewer": "%{name} 查看器",
      "images": "图片",
      "stats": "统计",
      "login": "登录",
      "signUp": "注册",
      "embed": "嵌入式小组件",
      "apiV1": "API V1",
      "apiV1Schema": "架构",
      "apiV1Pagination": "分页",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "架构",
      "hangar": {
        "index": "我的机库",
        "preview": "我的机库预览",
        "stats": "我的机库统计",
        "import": "导入",
        "public": "%{user} 机库",
        "publicStats": "%{user} 机库统计",
        "wishlist": "心愿单",
        "publicWishlist": "%{user} 心愿单",
        "vehicleLoadouts": "飞船配装",
        "inventories": "My Hangar Inventories",
        "inventory": "%{inventory}",
        "vehicleCargo": "飞船货物",
        "buybacks": "可回购承诺",
        "paints": "涂装",
        "flair": "机库装饰",
        "upgrades": "升级 / CCU",
        "equipment": "FPS 装备",
        "imports": "导入记录",
        "transfers": "转移",
        "vehicleOverview": "舰船概览",
        "vehicleLog": "舰长日志"
      },
      "requestPassword": "请求密码",
      "changePassword": "更改密码",
      "fleets": {
        "add": "创建新舰队",
        "preview": "舰队预览",
        "invites": "舰队邀请",
        "members": {
          "index": "%{fleet} Members",
          "invites": "%{fleet} Invites",
          "worldmap": "%{fleet} 成员世界地图",
          "starmap": "%{fleet} 成员星图",
          "health": "%{fleet} 成员健康检查"
        },
        "squadrons": {
          "index": "%{fleet} 中队",
          "overview": "%{fleet} 中队概览",
          "members": "%{fleet} 中队成员",
          "create": {
            "details": "创建中队 - %{fleet}",
            "appearance": "中队外观 - %{fleet}",
            "discord": "中队 Discord - %{fleet}"
          },
          "edit": {
            "details": "编辑中队 - %{fleet}",
            "appearance": "中队外观 - %{fleet}",
            "discord": "中队 Discord - %{fleet}"
          }
        },
        "stats": "%{fleet} 统计",
        "blueprints": "%{fleet} 的蓝图",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories",
          "transfers": "%{fleet} 转移"
        },
        "missions": {
          "index": "%{fleet} 任务",
          "create": "创建任务 - %{fleet}",
          "edit": {
            "details": "编辑任务 - %{fleet}",
            "teams": "编辑小队与席位 - %{fleet}"
          },
          "show": "%{fleet} 任务"
        },
        "events": {
          "index": "%{fleet} 活动",
          "calendar": "%{fleet} 日历",
          "create": "创建活动 - %{fleet}",
          "edit": {
            "details": "编辑活动 - %{fleet}",
            "schedule": "编辑日程 - %{fleet}",
            "signup": "编辑报名 - %{fleet}",
            "teams": "编辑小队与席位 - %{fleet}"
          },
          "show": "%{fleet} 活动",
          "payouts": "%{fleet} 活动分账"
        },
        "tours": {
          "index": "%{fleet} 行程",
          "create": "创建行程 - %{fleet}",
          "show": "%{fleet} 行程"
        },
        "settings": {
          "index": "%{fleet} 设置",
          "fleet": "%{fleet} 设置",
          "rsi": "%{fleet} 舰队 ID 与 RSI",
          "membership": "%{fleet} 成员资格",
          "roles": "%{fleet} 角色",
          "squadrons": "%{fleet} 中队",
          "allies": "%{fleet} 盟友",
          "notifications": "%{fleet} 通知设置",
          "discord": "%{fleet} Discord 设置",
          "calendar": "%{fleet} 日历设置",
          "features": "%{fleet} 功能",
          "contracts": "%{fleet} 合约设置"
        },
        "contracts": {
          "index": "合约",
          "create": "创建合约",
          "edit": "编辑合约",
          "show": "合约",
          "payouts": "%{fleet} 合同分账"
        },
        "directory": "舰队目录"
      },
      "roadmap": {
        "index": "路线图",
        "ships": "舰船路线图",
        "changes": "路线图变更"
      },
      "settings": {
        "index": "个人设置",
        "profile": "个人资料设置",
        "account": "账户",
        "hangar": "机库设置",
        "privacy": "隐私设置",
        "features": "功能标志",
        "connections": "连接",
        "oauthApplications": "OAuth 应用",
        "notifications": "通知设置",
        "calendar": "日历订阅",
        "donations": "捐赠",
        "security": "账户安全",
        "twoFactor": {
          "enable": "启用双因素认证",
          "disable": "禁用双因素认证",
          "backupCodes": "生成双因素备份代码"
        },
        "friends": "好友"
      },
      "compare": {
        "ships": "比较舰船"
      },
      "notFound": "404",
      "tools": {
        "index": "工具",
        "travelTimes": "旅行时间",
        "cargoGrids": "货物网格",
        "tradeRoutes": "贸易路线",
        "tours": {
          "index": "行程",
          "add": "创建新行程",
          "show": "%{tour}",
          "join": "加入行程"
        }
      },
      "impressum": "版权声明",
      "support": "支持",
      "share": "分享",
      "privacyPolicy": "隐私政策",
      "cookiePolicy": "Cookie政策",
      "visualTests": {
        "blueprints": "蓝图 - 视觉测试",
        "index": "视觉测试",
        "panels": "面板 - 视觉测试",
        "buttons": "按钮 - 视觉测试",
        "events": "活动",
        "typography": "排版 - 视觉测试",
        "forms": "表单 - 视觉测试",
        "tables": "表格 - 视觉测试",
        "lists": "列表 - 视觉测试",
        "metrics": "指标 - 视觉测试",
        "states": "状态 - 视觉测试",
        "notifications": "通知 - 视觉测试",
        "dedicationPlaques": "命名铭牌 - 视觉测试",
        "syncModal": "同步弹窗 - 视觉测试",
        "buybackSyncModal": "回购同步弹窗 - 视觉测试",
        "rsiVerificationModal": "RSI 验证弹窗 - 视觉测试",
        "fleetRsiVerificationModal": "舰队 RSI 验证弹窗 - 视觉测试",
        "overlays": "浮层 - 视觉测试",
        "installPrompt": "安装提示 - 视觉测试",
        "supportHint": "支持提示 - 视觉测试",
        "media": "媒体 - 视觉测试",
        "charts": "图表 - 视觉测试",
        "themes": "主题 - 视觉测试",
        "alerts": "提示 - 视觉测试",
        "verifiedBadges": "验证徽章 - 视觉测试",
        "chips": "Chips - 视觉测试",
        "squadrons": "中队 - 视觉测试",
        "notificationCenter": "通知中心 - 视觉测试"
      },
      "admin": {
        "locations": {
          "index": "地点",
          "show": "%{location}"
        },
        "blueprints": {
          "index": "蓝图",
          "show": "%{blueprint}"
        },
        "missions": {
          "index": "任务",
          "show": "%{mission}"
        },
        "models": {
          "index": "模型",
          "new": "新模型",
          "edit": {
            "index": "编辑 %{manufacturer} %{model}",
            "metrics": "编辑 %{manufacturer} %{model} 指标",
            "prices": "编辑 %{manufacturer} %{model} 价格",
            "fleetchart": "编辑 %{manufacturer} %{model} 舰队图表图片",
            "positions": "编辑 %{manufacturer} %{model} 乘员岗位",
            "hardpoints": "编辑 %{manufacturer} %{model} 挂载点",
            "cargoAndFuel": "编辑 %{manufacturer} %{model} 燃料",
            "cargoHolds": "编辑 %{manufacturer} %{model} 货舱",
            "docks": "编辑 %{manufacturer} %{model} 停靠点",
            "modules": "编辑 %{manufacturer} %{model} 模块",
            "paints": "编辑 %{manufacturer} %{model} 涂装",
            "images": "编辑 %{manufacturer} %{model} 图片",
            "videos": "编辑 %{manufacturer} %{model} 视频",
            "loaners": "编辑 %{manufacturer} %{model} 借用",
            "snubCrafts": "编辑 %{manufacturer} %{model} 微型舰载机",
            "upgrades": "编辑 %{manufacturer} %{model} 升级",
            "packages": "编辑 %{manufacturer} %{model} 包",
            "history": "编辑 %{manufacturer} %{model} 修改历史"
          }
        },
        "components": {
          "index": "组件",
          "new": "新组件",
          "edit": {
            "index": "编辑组件",
            "prices": "Edit Component Prices",
            "history": "编辑组件修改历史"
          }
        },
        "manufacturers": {
          "index": "制造商",
          "new": "新制造商",
          "edit": {
            "index": "编辑制造商"
          }
        },
        "announcements": {
          "index": "公告",
          "new": "新建公告",
          "edit": "编辑公告",
          "show": "公告"
        },
        "supporterContributions": {
          "index": "支持者贡献",
          "new": "新建支持者贡献",
          "edit": "编辑支持者贡献"
        },
        "fundingGoals": {
          "index": "资金目标",
          "new": "新建资金目标",
          "edit": "编辑资金目标"
        },
        "users": {
          "index": "用户",
          "edit": "编辑用户",
          "inventories": "用户库存列表",
          "inventory": "用户库存",
          "inventoryItem": "库存条目",
          "fleets": "用户舰队",
          "supporterContributions": "用户支持者贡献"
        },
        "vehicles": {
          "index": "载具",
          "edit": "编辑载具"
        },
        "admins": {
          "index": "管理员",
          "new": "新建管理员",
          "edit": "编辑管理员"
        },
        "fleets": {
          "index": "舰队",
          "edit": "编辑舰队",
          "members": "舰队成员",
          "memberEdit": "编辑舰队成员",
          "history": "舰队修改历史",
          "roles": "舰队角色列表",
          "role": "舰队角色",
          "inventories": "舰队库存列表",
          "inventory": "舰队库存",
          "inventoryItem": "库存条目"
        },
        "oauthApplications": {
          "index": "OAuth 应用",
          "new": "新建 OAuth 应用",
          "edit": "编辑 OAuth 应用"
        },
        "features": {
          "index": "功能标志",
          "show": "功能详情",
          "overview": "功能标志",
          "users": "功能标志用户",
          "fleets": "功能标志舰队",
          "history": "功能标志历史"
        },
        "images": {
          "index": "图片"
        },
        "notifications": {
          "index": "通知"
        },
        "maintenance": {
          "index": "维护",
          "pghero": "PgHero",
          "features": "功能",
          "flipper": "Flipper UI",
          "workers": "工作进程",
          "tasks": "任务",
          "imports": "导入",
          "importDetail": "导入详情",
          "rsiApiStatus": "RSI API 状态",
          "buildCompare": "版本对比"
        },
        "modelPaints": {
          "index": "模型涂装",
          "edit": "编辑模型涂装"
        },
        "modelModules": {
          "index": "模型模块",
          "edit": {
            "index": "编辑 %{name} 基本数据",
            "models": "编辑 %{name} 模型",
            "prices": "编辑 %{name} 价格",
            "hardpoints": "编辑 %{name} 挂载点",
            "docks": "编辑 %{name} 停靠点",
            "cargoHolds": "编辑 %{name} 货舱",
            "history": "编辑模块修改历史"
          }
        },
        "unlistedModels": {
          "index": "未收录的飞船"
        },
        "modelModulePackages": {
          "index": "模型模块包"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "prices": "Edit Equipment Prices"
          }
        },
        "visualTests": {
          "index": "视觉测试",
          "notifications": "通知 - 视觉测试"
        }
      },
      "notifications": "通知",
      "component": "%{name}",
      "commodity": "%{name}",
      "commodities": {
        "index": "商品"
      },
      "components": {
        "index": "部件"
      },
      "blueprints": {
        "index": "蓝图"
      },
      "missions": {
        "index": "任务"
      },
      "equipment": {
        "index": "装备"
      },
      "equipmentItem": "%{name}"
    }
  }
}
